import { API_PROCEDURE_RECREATE } from "../../../config";
import httpClient from "../../../httpClient";

export const recreateProcedure = {
    recreate: (id) => httpClient.get(API_PROCEDURE_RECREATE + "/" + id),
};
